import { firstMissing, STEPS } from '@/features/studio-renew/steps'

import type { Character, Chat } from '@/features/studio-renew/types'

/** 단계 이름·순서·필수 여부는 편집과 제출이 같은 정의를 사용한다. */
export const WORK_FLOW = STEPS.work

/** 저장된 옛 주소와 완성도 링크도 해당 기능이 있는 단계에서 이어 쓴다. */
export function workFlowStep(step: string): string {
  if (step === 'review') return 'publish'
  if (step === 'status' || step === 'commands') return 'tools'
  return step === 'test' || WORK_FLOW.some((item) => item.id === step)
    ? step
    : WORK_FLOW[0].id
}

export function workEntryStep(
  chat: Chat,
  characters: Record<string, Character>
): string {
  return firstMissing('work', { chat, characters })?.id ?? 'publish'
}
